<template>
    <div>
        <ReceiptInfo ref="receiptInfo" :receiptId.sync="receiptId" :id="id"></ReceiptInfo>
        <div v-if="data2" class="group MT20">
            <div class="page-group-title"><span>结款身份</span></div>
            <table class="info-table MT20" style="width:100%">
                <tr>
                    <th>结款方身份</th>
                    <td>{{ $userType.get(data2.applyUserType) }}</td>
                </tr>
                <tr>
                    <th>结款方ID</th>
                    <td>{{ data2.applyUserId }}</td>
                </tr>
                <tr>
                    <th>结款方名称</th>
                    <td>{{ data2.applyUserName }}</td>
                </tr>
            </table>
        </div>
        <div v-if="data2" class="group MT20">
            <div class="page-group-title"><span>结算数据参考</span></div>

            销售截止时间:
            <el-date-picker v-model="applyEndTime" type="datetime" size="small" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择销售截止时间"
                class="MR10 ML10">
            </el-date-picker>

            <el-button type="primary" plain @click="getData2()" size="small" :loading="dataLoading2">查询</el-button>
            <!-- <el-button v-if="$utils.have('/goodsReceivablesAudit/audi/reference/excel')"  type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading">导出明细</el-button> -->

            <table class="info-table MT20" width="100%">
                <tr>
                    <th>销售商品数</th>
                    <td>{{ data2.saleNum }}</td>
                    <th>销售金额<span class="color-info font10">(由收入扣除未结算且待退款和已退款的金额而来)</span></th>
                    <td class="color-danger">{{ data2.saleAmountFormat }}</td>
                </tr>
                <tr>
                    <th>商家承担优惠</th>
                    <td>{{ data2.busDiscountFormat }}</td>
                    <th>服务费用</th>
                    <td colspan="3">{{ data2.serviceFeeAmountFormat }}</td>
                </tr>
                <tr>
                    <th>已结算商品退款数</th>
                    <td>{{ data2.refundNum || 0}}</td>
                    <th>已结算商品退款金额<span class="color-info font10">(将返回之前结算时扣除的服务费)</span></th>
                    <td class="color-danger">{{data2.refundAmountStr || 0}} - {{data2.refundAmountServiceStr || 0}} = {{ data2.refundAmountFinalStr || 0}}</td>
                </tr>
                <tr>
                    <th>预计结款</th>
                    <td colspan="3" class="color-danger">
                        {{ data2.saleAmountFormat }} - {{ data2.busDiscountFormat }} - {{ data2.serviceFeeAmountFormat }} - {{ data2.refundAmountFinalStr || 0}} =
                        {{ data2.proposeAmountFormat }}
                        <p class="color-info">销售金额 - 商家承担优惠 - 服务费用 - 已结算商品退款金额<span class="font10">(将返回之前结算时扣除的服务费)</span></p>
                    </td>
                </tr>
            </table>

            <template v-if="data2.shopGoodsRefundStatisticList && data2.shopGoodsRefundStatisticList.length > 0">
                <div class="MT20">已结算退款：</div>
                <el-table :data="data2.shopGoodsRefundStatisticList" border style="width: 100%" v-loading="dataLoading2"
                    size="small" stripe max-height="250" class="MT20">
                    <el-table-column prop="id" label="ID"></el-table-column>
                    <el-table-column prop="name" label="名称" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="balanceType " label="结算方式" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.balanceType==1" >自营-预付款</span>				        
                            <span v-else-if="scope.row.balanceType==2">代销-后付款</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="refundNum" label="退款数"></el-table-column>
                    <el-table-column prop="refundAmount" label="退款金额"></el-table-column>
                    <el-table-column prop="serviceFee" label="服务费率">
                        <template slot-scope="scope">{{ scope.row.serviceFee }}%</template>
                    </el-table-column>
                </el-table>
            </template>

            <template>
                <div class="MT20">商品销售：</div>
                <el-table :data="data2.shopGoodsSaleStatisticList" border style="width: 100%" v-loading="dataLoading2"
                    size="small" stripe max-height="250" class="MT20">
                    <el-table-column prop="id" label="ID"></el-table-column>
                    <el-table-column prop="name" label="名称" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="balanceType " label="结算方式" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.balanceType==1" >自营-预付款</span>				        
                            <span v-else-if="scope.row.balanceType==2">代销-后付款</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleNum" label="销售数"></el-table-column>
                    <el-table-column prop="saleAmountFormat" label="销售金额"></el-table-column>
                    <el-table-column prop="serviceFee" label="服务费率">
                        <template slot-scope="scope">{{ scope.row.serviceFee }}%</template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <!-- <div v-if="receiptId && data2 && data2.goodsOrderDetailIdList.length > 0" class="group MT20">
            <div class="page-group-title"><span>结款信息</span></div>
            <SettlementEdit ref="settlementEdit" :btnLoading.sync="btnLoading" :applyEndTime.sync="applyEndTime"
                :playInfo.sync="data2"></SettlementEdit>
        </div> -->
        <div class="group MT20">
            <el-button @click="goBack">返回</el-button>
            <el-button v-if="receiptId && data2 && data2.goodsOrderDetailIdList.length > 0" type="primary"
                @click="onSubmit()" :loading="btnLoading">创建结款单</el-button>
        </div>
    </div>
</template>
<script>
// import SettlementEdit from '../components/settlementEdit';
import ReceiptInfo from '../components/receiptInfo';
import { downloadFileTmp } from '@/assets/js/commonApi.js';
export default {
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },
    components: { /*SettlementEdit,*/ ReceiptInfo },
    data() {
        return {
            btnLoading: false,
            data2: null,
            dataLoading2: false,
            applyEndTime: "",
            downLoading: false,
            receiptId: '',
            redirect: this.$route.query.redirect
        }
    },
    mounted() {
        this.getData2();
    },
    methods: {
        //获取结款参考信息
        getData2() {
            this.dataLoading2 = true;
            this.$request({
                url: '/goodsReceivablesAudit/audi/reference',
                params: {
                    payeeUserId: this.id,
                    applyEndTime: this.applyEndTime
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data2 = result;
                    } else {
                        this.$message.error(msg || "获取结参考失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取结参考失败,请重试");
                })
                .finally(() => {
                    this.dataLoading2 = false;
                });
        },
        //导出费用明细
        async download(id) {
            let filePath, fileName;
            this.downLoading = true;
            const res = await this.$request({
                url: '/goodsReceivablesAudit/audi/excel',
                method: 'post',
                params: {
                    id: id,
                },
            })
                .catch(err => {
                    this.$message({ message: err.message, type: 'error' });
                })
            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                filePath = result.url;
                fileName = result.fileName;
            } else {
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }

            await downloadFileTmp(filePath,`${fileName}.`+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //导出异常
        async exportReconciliation(ids){
            let filePath;
            const res = await this.$request({
                url:'/finance/exportReconciliation',
                method: 'post',
                params: {orderIds: ids},
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'异常订单.'+this.$utils.getFileType(filePath));
        },
        onSubmit() {
            if(!this.applyEndTime){
                return this.$message.error('请填写销售截止时间');
            }      
            this.$confirm('确定创建结款单？结款单创建成功后，会锁定关联订单，付款前这些订单不能取消和二次申请结算。', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const _formData = {
                    applyEndTime: this.applyEndTime,
                    applyUserId: this.data2.applyUserId,
                    playInfo: {
                        goodsOrderDetailIdList: this.data2.goodsOrderDetailIdList || [],
                        proposeAmount: this.data2.proposeAmountFormat || 0,
                        refundAmount: this.data2.refundAmountStr || 0,
                        refundAmountFinal: this.data2.refundAmountFinalStr || 0,
                        refundNum: this.data2.refundNum || 0,
                        refundOrderDetailIdList: this.data2.refundOrderDetailIdList || [],
                        serviceFeeAmount: this.data2.serviceFeeAmountFormat	|| 0,
                        refundAmountService: this.data2.refundAmountServiceStr || 0,
                        totalAmount: this.data2.saleAmountFormat || 0,
                        totalSell: this.data2.saleNum || 0,
                        totalSubsidyAmount: parseFloat(this.data2.busDiscountFormat || 0) + parseFloat(this.data2.platDiscountFormat || 0),
                        userSubsidyAmount: this.data2.busDiscountFormat || 0,
						normalRefundOrderDetailIdList:this.data2.normalRefundOrderDetailIdList || []
                    }
                }
				
				
                const _url = '/goodsReceivablesAudit/audi/createAudi';
                this.btnLoading = true;
                const res = await this.$request({
                    url: _url,
                    data: _formData,
                    method: "post",
                })
                    .catch(() => {
                        this.$message.error("操作失败,请重试");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });

                if(res){
                    const { result} = res.data;
                    if( result.result == 2 ){
                        this.$confirm(`结算单创建失败，账期内有<span class="color-danger">${result.orderId && result.orderId.length}个</span>未经过收款验收确认的订单`, '提示', {
                            type: 'warning',
                            center: true,
                            closeOnClickModal: false,
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '导出对账异常订单',
                        }).then(() => {
                            this.exportReconciliation(result.orderId.toString())
                        }).catch(() => {})
                    }else if( result.result == 3 ){
                        this.$alert('当前有尚未结算的结款单，不能再创建结款单', '提示', {});
                    }else{
                        this.$confirm('结款单创建成功，可以去列表查看或者导出明细数据', '提示', {
                            type: 'success',
                            center: true,
                            closeOnClickModal: false,
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '导出明细',
                            cancelButtonText: '去列表',
                            distinguishCancelAndClose: true,
                            closeOnPressEscape: false
                        }).then(() => {
                            this.download(result.id);
                        }).catch((action) => {
                            // this.goBack();
                            // this.$emit('onUpdate');
                            if( action == 'cancel' ){
                                this.$router.push({
                                    path: "/finance/goods/settlement/detail",
                                });
                            }
                        })
                    }
                }else{
                    this.goBack();
                    this.$emit('onUpdate');
                }

            }).catch(() => {})    

        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
    }
}
</script>


<style lang="scss" scoped>
::v-deep .info-table {
    th {
        width: 200px;
    }
}
.font10{
	font-size: 10px;
}
</style>